import React from 'react';
import BrandedMissionName from '../common/BrandedMissionName';

const HomeTrademark = () => {
  return (
    <section className="bg-white px-6 py-14 md:px-12">
      <div className="mx-auto max-w-5xl space-y-10">
        <div className="text-center">
          <p className="text-base leading-relaxed text-gray-700 md:text-lg">
            <span className="font-semibold text-gray-800">Note:</span>{' '}
            <BrandedMissionName /> is a pending trademark under Class 41.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HomeTrademark;


